import Store from '@/store/modules/Viewer'

export default (ifcType: number) => {
  return Store.allTypes[ifcType]
}
